import axios from "axios";
import { replaceImageUrlsInPlace } from "@/utils/imageUrl";

axios.interceptors.response.use(
  (response) => {
    if (
      response &&
      response.data &&
      typeof response.data === "object" &&
      response.config &&
      (!response.config.responseType || response.config.responseType === "json")
    ) {
      replaceImageUrlsInPlace(response.data);
    } else if (typeof response.data === "string") {
      response.data = replaceImageUrlsInPlace(response.data);
    }

    return response;
  },
  (error) => Promise.reject(error)
);
